<style scoped>
.operte-btns {
  background: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
}

.operte-btns .btn {
  padding: 5px 18px;
  border: 1px solid rgba(217, 217, 217, 1);
  border-radius: 2px;
  cursor: pointer;
  margin-right: 10px;
}

.operte-btns .btn.save {
  border: 1px solid rgba(79, 161, 164, 1);
  color: rgba(79, 161, 164, 1);
  cursor: pointer;
}

.operte-btns .btn.submit {
  border: 1px solid rgba(79, 161, 164, 1);
  background: rgba(79, 161, 164, 1);
  color: #fff;
  cursor: pointer;
}

.operte-btns .cancel {
  margin-left: 230px;
}

.conBox {
  display: flex;
  align-items: flex-start;
  width: 100%;
  padding: 5px;
  box-sizing: border-box;
  position: relative;
  overflow-y: scroll;
}

.conBox .navList {
  width: 140px;
  background: #fff;
  position: fixed;
  top: 90px;
}

.conBox .navList .title {
  height: 64px;
  line-height: 64px;
  font-size: 20px;
  border-bottom: 1px solid #f6f7fa;
}

.conBox .navList .cell {
  margin: 4px 10px;
  line-height: 32px;
  cursor: pointer;
}

.conBox .navList .active {
  background: #eaf7f7;
}

.conBox .conList {
  flex: 1;
  padding: 0 0 0 146px;
  box-sizing: border-box;
}

.conBox .conList .cellBox {
  background: #fff;
  margin-bottom: 8px;
  padding: 16px;
}

/* .conBox .conList .cellBox .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f6f7fa;
  padding: 0 10px 16px 10px;
  margin-bottom: 16px;
} */

.conBox .conList .cellBox .title .left {
  font-size: 20px;
}

.conList .cellBox .title .right span {
  background: #4fa1a4;
  color: #fff;
  padding: 6px 20px;
  display: inline-block;
  margin-left: 14px;
  cursor: pointer;
}

.conBox .userInfo {
  width: 300px;
  background: #fff;
}

/* 右侧公司信息 */
.carouselBox {
  padding: 16px;
  box-sizing: border-box;
}

.carouselBox .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  padding-bottom: 16px;
  border-bottom: 1px solid #f6f7fa;
}

.carouselBox .title .left {
  color: #323232;
  font-size: 20px;
}

.carouselBox .title .right {
  font-size: 14px;
  display: flex;
  align-items: center;
  color: #909399;
}

.carouselBox .title .right img {
  width: 18px;
  height: 18px;
}

.right {
  z-index: 10;
  top: 10px;
  right: 25px;
  position: absolute;
}

.carouselBox .con {
  position: relative;
  color: #323232;
  font-size: 14px;
  padding-top: 30px;
  border-bottom: 1px solid #f6f7fa;
  padding-bottom: 16px;
  margin-bottom: 20px;
}

.carouselBox .con .userIcon {
  width: 96px;
  height: 96px;
  overflow: hidden;
  background: #f6f7fa;
  border-radius: 8px;
  margin: 0 auto;
  position: relative;
  cursor: pointer;
}

.carouselBox .con .userIcon:hover span {
  display: inline-block;
}

.carouselBox .con .userIcon span {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  line-height: 26px;
  color: #fff;
  background: rgba(0, 0, 0, 0.7);
  display: none;
}

.carouselBox .con .userIcon img {
  width: 100%;
}

.carouselBox .con .name {
  font-size: 30px;
  margin: 10px 0 4px 0;
}

.carouselBox .con .userType {
  position: absolute;
  left: 0;
  top: 0;
}

.carouselBox .con .userType p {
  display: flex;
  align-items: center;
  margin: 0;
}

.carouselBox .con .userType p img {
  width: 16px;
  height: 16px;
}

.carouselBox .con .userType .zhengshi {
  color: #4fa1a4;
}

.carouselBox .con .userType .shiyong {
  color: #e59940;
}

.bottom .line {
  display: flex;
  align-items: flex-start;
  padding: 10px 10px 0 20px;
}

.carouselBox .bottom .line img {
  width: 16px;
  height: 16px;
  margin-right: 4px;
}

.carouselBox .bottom .line span {
  color: #323232;
  text-align: left;
  font-size: 14px;
}

.userInfo .opreate {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  color: #909399;
  position: absolute;
  bottom: 16px;
  width: 100%;
  padding: 0 16px;
  box-sizing: border-box;
}

.userInfo .opreate span {
  cursor: pointer;
}

.userInfo /deep/ .el-carousel__container {
  height: 520px;
  position: relative;
}

.userInfo /deep/ .el-carousel__arrow {
  display: none;
}

.userInfo /deep/ .el-carousel__indicators--horizontal {
  display: none;
}

.brokerInsuredDetail .content /deep/ .el-form-item {
  margin-bottom: 12px;
}
::v-deep .el-collapse-item__header {
  padding-left: 10px;
  font-size: 16px;
}
.el-collapse-item__header {
  padding-left: 10px;
}
.el-collapse-item__header {
  height: 40px;
}
.el-collapse-item__content .title {
  padding: 0px;
}
.conBox .conList .cellBox .title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f6f7fa;
}
.conBox .conList .cellBox {
  position: relative;
  padding: 0px;
  margin: 0px;
}
::v-deep #forbiddenText .fieldItemClass .dialog-form {
  display: flex;
  flex-direction: column;
}

::v-deep #forbiddenText .fieldItemClass .el-form-item {
  display: flex;
  flex-direction: column;
}

::v-deep #forbiddenText .fieldItemClass .el-form-item__label {
  width: 100%;
  text-align: left;
  line-height: 22px;
  margin-left: 10%;
}

::v-deep #forbiddenText .fieldItemClass .dialog-form .el-col-12 {
  width: 100%;
}

#forbiddenText .fieldItemClass .el-form .el-form-item .el-form-item__content {
  margin-left: -11% !important;
}
</style>
<style>
#rewardsPunishments
  .fieldItemClass
  .el-form
  .el-form-item
  .el-form-item__label {
  width: 13%;
}
#forbiddenText .fieldItemClass .el-form .el-form-item .el-form-item__content {
  margin-left: -11% !important;
}
.brokerInsuredDetail .el-button{
  margin-right: 10px;
}
.el-collapse-item{
  position: relative;
}
.el-collapse-item .el-collapse-item__arrow{
  position: absolute;
  top: 18px;
  right: 0px;
}
</style>
<template>
  <div
    class="brokerInsuredDetail"
    v-loading.fullscreen.lock="fullscreenLoading"
  >
    <div class="conBox" :style="'height:' + conHeight + 'px;'">
      <div class="navList">
        <div class="title">人员详情</div>
        <div
          :class="currentGroup == index ? 'cell active' : 'cell'"
          v-for="(item, index) in allGroupData"
          :key="index"
          @click="handleLeft(index)"
        >
          {{ item.name }}
        </div>
      </div>
      <div class="conList">
        <div
          class="cellBox"
          v-for="(item, index) in allGroupData"
          :key="index"
          :id="'id' + index"
        >
          <el-collapse v-model="activeNames">
            <template v-if="!flowType">
                  <div class="right" v-if="index != 1">
                    <el-button
                      :loading="item.submitLoading"
                      @click="saveForm(item, index)"
                      size="small"
                      
                      >保存</el-button
                    >
                  </div>
                  <div class="right" v-if="index == 1">
                    <el-button
                      :loading="item.submitLoading"
                      @click="saveForm(item, index)"
                      size="small"
                     
                      >保存</el-button
                    >
                  </div>
                </template>
            <el-collapse-item :title="item.name" :name="index + 1">
              <div class="title" >
                <!-- <span class="left">{{ item.name }} {{ item.formVisible }}</span> -->
                
              </div>
              <!-- :id="
              item[3].tableData[0].fieldName === 'rewardsPunishment'
                ? 'rewardsPunishments'
                : ''
            " -->
              <div class="content" :id="item.name == '背调结果信息' ? 'forbiddenText' : ''">
                <FieldItem
                  :guid="guid"
                  :formColumn="item.tableData"
                  :ref="'fieldItem' + index"
                  :form="formData"
                  :isEdit="item.isEdit"
                  :index="index"
                  @updateIsEdit="updateIsEdit"
                  @updateLading="updateLading(item)"
                  @dynamicModification="dynamicModification"
                  @dynamicModifications="dynamicModifications"
                ></FieldItem>
              </div>
            </el-collapse-item>
          </el-collapse>
        </div>
        <template v-if="flowType">
          <div style="height: 50px"></div>
          <div class="operte-btns">
            <div class="btn cancel" @click="$router.go(-1)">取消</div>
            <div class="btn submit" @click="saveReq">提交申请</div>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import { route } from "@/api/apiRoute";
import FieldItem from "./fieldItem.vue";
export default {
  data() {
    return {
      urlImg: `/${serverConfig.msCommonAdminCloudService}/obs/upload-image`,
      conHeight: window.innerHeight - 85,
      currentGroup: 0,
      listBoxState: true, //处理导航
      allGroupData: [], //全部分组
      allFiledData: [], //全部字段
      formData: {},
      companyInfo: [], //公司信息
      timeId: null,
      guid: null,
      flowType: null, //流程
      fullscreenLoading: false,
      // 卡必填的数据
      pdeerArr: [],
      theValuePassedOver: {},
      activeNames: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
    };
  },
  components: {
    FieldItem,
  },
  watch: {
    formData: {
      handler(newVal) {},
      immediate: true,
      deep: true,
    },
  },
  created() {
    this.getGroupList()
    if (this.$route.query.approvalState !=='Y') { // 简历同步花名册不走审批流
      this.getAddApproval();
    }
    //在职状态
    let incumbentStatus = null;
  },
  mounted() {
    window.addEventListener("scroll", this.bodyScroll, true);
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.bodyScroll, true);
  },
  methods: {
    //更新可编辑状态
    updateIsEdit(data) {
      this.guid = data.guid;
      if (this.$route.query.cvInfoGuid) {
          this.syncRoster(this.$route.query.cvInfoGuid,'Y',()=>{
          this.$router.go(-1);
        })
      }
    },
    //更新保存加载状态
    updateLading(item) {
      item.submitLoading = !item.submitLoading;
    },
    //保存
    saveForm(item, index) {
      if (index != 0 && !this.guid) {
        this.$message.error(
          `请先完善基本信息再完善${this.allGroupData[index].name}`
        );
        return;
      }
      this.$refs["fieldItem" + index][0].saveForm();
    },
    //获取分组列表
    getGroupList(type) {
      let params = {
        pageSize: 100,
        pageIndex: 1,
        groupName: "",
        tenantGuid: this.$store.state.guid,
      };
      this.api
        .get(`/${serverConfig.msConfigureService}/cfg/group/list`, params)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            let chebianArr= res.data.data.records? res.data.data.records: [];
    
        chebianArr.splice(1,1)
        this.allGroupData   = chebianArr
        this.getFieldList();
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //获取字段列表
    getFieldList() {
      let params = {
        pageSize: 500,
        pageIndex: 1,
        tenantGuid: this.$store.state.guid, // '3d3861e610cb40218d3ecf641147affd',
        chineseName: '',
        fieldType: ''
      }
      this.api.get(`/${serverConfig.msConfigureService}/cfg/field/list`, params).then(res => {
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.allFiledData = res.data.data.records ? res.data.data.records : []

          this.allGroupData.forEach(item => {
            let tableData = []
            this.allFiledData.forEach(oneData => {
              if (oneData.groupGuid == item.guid) {
                oneData.dataSource = oneData.dataSource ? JSON.parse(oneData.dataSource) : []
                tableData.push(oneData)
              }
            })
            tableData.sort((a, b) => { return a.formOrderNum - b.formOrderNum })
            this.$set(item, 'tableData', tableData)
            this.$set(item, 'isEdit', false)
            this.$set(item, 'submitLoading', false)

            // console.log(1,this.allGroupData );
            let classArr = []
            let nameArr = []
            this.allGroupData.forEach(item => {
              nameArr.push(item.tableData)
              classArr.push(item.name)
            })
          })
          // ! 简历信息同步
          this.$nextTick(()=>{
            if (this.$route.query.cvInfoGuid) this.getCvInfo(this.$route.query.cvInfoGuid)
          })
          // this.getDetail() //获取到表单字段后，再获取表单数据
        } else {
          this.$message.error(res.data.msg);
        }
      });
    },
    //禁用状态
    disableEvent() {},
    //页面滚动监听
    bodyScroll() {
      clearTimeout(this.timeId);
      this.timeId = setTimeout(() => {
        this.scrollToTop();
      }, 100);
    },
    // 点击导航菜单，页面滚动到指定位置
    handleLeft(index) {
      this.currentGroup = index;
      this.$el.querySelector(`#id${index}`).scrollIntoView({
        behavior: "smooth", // 平滑过渡
        block: "start", // 上边框与视窗顶部平齐。默认值
      });
      this.listBoxState = false;
      let timeId;
      clearTimeout(timeId);
      timeId = setTimeout(() => {
        this.listBoxState = true;
      }, 200);
    },
    // 监听页面元素滚动，改变导航栏选中
    scrollToTop() {
      // 获取视窗高度
      var domHight = document.body.offsetHeight;
      // dom滚动位置
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (this.listBoxState) {
        //作用是点击导航栏时，延迟这里执行。
        this.allGroupData.map((v, i) => {
          // 获取监听元素距离视窗顶部距离
          var offsetTop = document.getElementById(`id${i}`).offsetTop;
          // 获取监听元素本身高度
          var scrollHeight = document.getElementById(`id${i}`).scrollHeight;
          // 如果 dom滚动位置 >= 元素距离视窗距离 && dom滚动位置 <= 元素距离视窗距离+元素本身高度
          // 则表示页面已经滚动到可视区了。
          if (scrollTop >= offsetTop && scrollTop <= offsetTop + scrollHeight) {
            // 导航栏背景色选中
            this.currentGroup = i;
          }
        });
      }
    },
    //判断该新增是否走新增流程
    getAddApproval() {
      let req = {
        flowOperationType: 1,
        functionCode: "HMCGL",
        tenantGuid: localStorage.guid,
      };
      this.api
        .get(
          `/${serverConfig.msConfigureService}/function-workflow/data/get-flow-template-guid`,
          req
        )
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (res.data.data) {
              this.flowType = res.data.data.flowType;
            }
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    //提交新增流程
    saveReq() {
      let list = [];
      let scrollIndex;
      this.allGroupData.forEach((item, index) => {
        // 下面这个就是10个fieldItem的 校验, 改几个字段格式后,在返回出来后面要提交给后端接口的 对象
        this.$refs["fieldItem" + index][0].saveOneForm();
        list.push(this.$refs["fieldItem" + index][0].newForm);
      });
      console.log(list);
      list.some((item, index) => {
        if (!item) {
          scrollIndex = index;
          return !item;
        }
      });
      //
      if (scrollIndex != null) {
        this.handleLeft(scrollIndex);
        return;
      }
       if (this.formData.baseCenter ==='1' || this.formData.baseCenter ==='3') {
        if (!this.formData.levyCompany) {
          this.$message.error("您选了终端服务中心,需要填写代征公司,才能提交!");
          let index = this.allGroupData.findIndex(item=>item.name === '奖金账户')
          if (index !=null) this.handleLeft(index);
          return;
        }
      }
     
      // contractNature:this.formData.contractNature? this.formData.contractNature: 3,
      this.$refs.fieldItem0[0].newForm.contractNature = this.formData
        .contractNature
        ? this.formData.contractNature
        : 3;

      let userInfo = JSON.parse(localStorage.userInfo);
      let arr = this.$refs.fieldItem0[0].newForm.promotionCategory.split("/");
      this.$refs.fieldItem0[0].newForm.promotionCategory = arr.join("、");
       
      let params = [
        {
          tenantGuid: this.$store.state.guid,
          rosterParam: this.$refs.fieldItem0[0].newForm,
          staffGuid: userInfo.staffGuid,

          actionType: "save",
          funcCode: "HMCGL",
        },
      ];

      this.fullscreenLoading = true;
      this.api.postJson(`/${serverConfig.msPersonnelService}/staff-roster/workflow/create-roster-approval`, params).then(res => {
        this.fullscreenLoading = false;
        if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
          this.$message.success('流程提交成功！');
          if (this.$route.query.cvInfoGuid) {
            this.syncRoster(this.$route.query.cvInfoGuid,'Y',()=>{
              this.$router.go(-1);
            })
          } else {
            this.$router.go(-1);
          }
        } else {
          this.$message.error(res.data.msg);
        }
      });


    },

    // ! =========== 简历同步花名册操作
    // 更新简历状态是否同步花名册
    syncRoster(guid,isSyncRoster,callBack) {
      let param = {
        guid,
        isSyncRoster
      };
      if (!param.guid) return;
      this.api
        .put(`/${serverConfig.msPersonnelService}/staff-resume/data/update`,param)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            this.$message.success('同步成功');
            if (callBack) callBack()
          } else {
            this.$message.error(res.data.msg);
          }
        });
    },
    // 通过简历guid取简历详情
    getCvInfo(guid) {
      let self = this;
      let query = {
        keyword: guid,
      };
      if (!query.keyword) return;
      self.api
        .postJson(`/${serverConfig.msPersonnelService}/staff-resume/data/get-detail?keyword=${query.keyword}`)
        .then((res) => {
          if (res.data.code == serverConfig.REQUIRE_SUCCESS_CODE) {
            if (!res.data.data) {
              this.$message.error('暂无简历信息')
              return
            }
            let cvItem = res.data.data
            this.syncCvInfo(cvItem) // 简历信息赋值
            
          } else {
            self.$message.error(res.data.msg);
          }
        });
    },
    syncCvInfo(item) {
      let cvInfo = {
        name:item.name, // 姓名
        mobileNo:item.mobileNo, // 电话
        professional:item.professional, // 专业
        sex:item.sex, // 性别
        idCode:item.idCode, // 证件号码
        education:item.education, // 学历
        graduatedFrom:item.graduatedFrom, // 毕业学校
      }
      let cvInfoKeyList = Object.keys(cvInfo)
      cvInfoKeyList.forEach(key=>{
        this.$set(this.formData,key,cvInfo[key])
      })
    },
    dynamicModification(res) {
      let { item } = res
      if (item && item.fieldName === 'baseCenter') {
        // todo 所属中心联动逻辑
        this.theValuePassedOver = res;
      }
      let self = this;

      if (res.value == 1 || res.value == 3) {
        console.log(111111111);
        let foundObj = self.allGroupData.find((item) => {
          return item.name == "奖金账户";
        });

        self.pdeerArr = foundObj.tableData;
        // pdeerArr.forEach((item) => {
        //   if ((item.fieldName = levyCompany)) {
        //     item.isRequired = "Y";
        //   }
        // });
        console.log(self.pdeerArr);
      }
    },
    dynamicModifications(res) {
      console.log(res);
      this.valueOver = res.value;

      if (this.valueOver == 1) {
        let terminalServicesCenterArr = [1, 2, 3, 4, 5, 6, 10];
        this.activeNames = terminalServicesCenterArr;
      } else if (this.valueOver == 2) {
        let dataAcquisitionCenterArr = [1, 2, 3, 4, 6, 7, 8, 9, 10];
        this.activeNames = dataAcquisitionCenterArr;
      } else if (this.valueOver == 3) {
        let marketArr = [1, 2, 3, 4, 5, , 10];
        this.activeNames = marketArr;
      } else {
        this.activeNames = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
      }
    },
  },
};
</script>
